import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpRequest} from '@angular/common/http';

import 'rxjs/add/operator/map';
import {TaskInstructionType} from '@app/shared/models/enums/task-instruction-type.enum';
import {AppUtils} from '@app/shared/util/app.utils';

@Injectable()
export class TasksService {
    static readonly API_TASKS_BASE_PATH = `${environment.baseURL}/api/operationTasks`;

    constructor(private http: HttpClient) {
    }

    getTask(id: number) {
        return this.http.get(`${TasksService.API_TASKS_BASE_PATH}/${id}`);
    }

    getTasks(searchTerm: string, activityId: number) {
        const params = {
            searchTerm: searchTerm || '',
            operationId: activityId ? activityId.toString() : ''
        };
        return this.http.get(`${TasksService.API_TASKS_BASE_PATH}`, {params: params});
    }

    createTask(task: any, activity: any) {
        const mappedTask = this.mapTask(task, activity);
        return this.http.post<any>(TasksService.API_TASKS_BASE_PATH, mappedTask);
    }

    updateTask(task: any, activity: any) {
        const mappedTask = this.mapTask(task, activity);
        return this.http.put(`${TasksService.API_TASKS_BASE_PATH}/${task.id}`, mappedTask);
    }

    deleteTask(id: number) {
        return this.http.delete(`${TasksService.API_TASKS_BASE_PATH}/${id}`);
    }

    updatePhotos(taskId, task: any) {
        return this.http.put<any>(`${TasksService.API_TASKS_BASE_PATH}/${taskId}/photos`, this.mapPhotos(task.photo.selectedImages));
    }

    downloadTaskDocument(taskId, documentId) {
        const req = new HttpRequest('GET', `${TasksService.API_TASKS_BASE_PATH}/${taskId}/documents/${documentId}/download`,
            null, {responseType: 'blob'});

        return this.http.request(req);
    }

    downloadDocuments(taskId, documentId) {

      const req = new HttpRequest('GET', `${TasksService.API_TASKS_BASE_PATH}/${taskId}/documents/${documentId}/download`,
        null, {responseType: 'blob'});

      return this.http.request(req);
    }

    mapTask(task: any, activity: any) {
        return {
            'id': task.id || 0,
            'name': task.name,
            'description': task.description,
            'identifier': task.identifier,
            'requiresObservation': task.requiresObservation,
            'duration': task.duration,
            'unit': task.unit,
            'hasSpare': task.hasSpare,
            'spareCode': task.spareCode,
            'mandatorySpare': task.mandatorySpare,
            'spareQuantity': task.spareQuantity || 0,
            'assignedRoleId': task.assigned.id,
            'operationId': activity.id,
            'files': this.mapFiles(activity.rootPath, task.workInstructions, task.spareInstructions)
        };
    }

    mapFiles(rootPath, workInstructions, spareInstructions) {
        const files = [];
        if (workInstructions) {
            files.push({
                RootPath: rootPath,
                FullPath: workInstructions,
                Type: TaskInstructionType.WORK
            })
        }
        if (spareInstructions) {
            files.push({
                RootPath: rootPath,
                FullPath: spareInstructions,
                Type: TaskInstructionType.SPARE
            })
        }
        return files;
    }

    mapPhotos(photos) {
        const formData = new FormData();
        if (!photos) {
            return formData;
        }

        photos.forEach((photo) => {
            if (photo.data) {
                const blob = AppUtils.buildBlobFromDataString(photo.data);
                formData.append('photos', blob as Blob, photo.name);
            } else {
                formData.append('photos', photo as Blob);
            }
        });
        return formData;
    }
}
